import InterBlack from '@assets/fonts/Inter-Black.ttf';
import InterBold from '@assets/fonts/Inter-Bold.ttf';
import InterExtraBold from '@assets/fonts/Inter-ExtraBold.ttf';
import InterExtraLight from '@assets/fonts/Inter-ExtraLight.ttf';
import InterLight from '@assets/fonts/Inter-Light.ttf';
import InterMedium from '@assets/fonts/Inter-Medium.ttf';
import InterRegular from '@assets/fonts/Inter-Regular.ttf';
import InterSemiBold from '@assets/fonts/Inter-SemiBold.ttf';
import InterThin from '@assets/fonts/Inter-Thin.ttf';
import JockeyOneRegular from '@assets/fonts/JockeyOne-Regular.ttf';
import LeagueGothicCondensed from '@assets/fonts/LeagueGothic-Condensed.ttf';
import LeagueGothicCondensedItalic from '@assets/fonts/LeagueGothic-CondensedItalic.ttf';
import LeagueGothicItalic from '@assets/fonts/LeagueGothic-Italic.ttf';
import LeagueGothicRegular from '@assets/fonts/LeagueGothic-Regular.ttf';

export const fontFamily = {
  inter: 'Inter',
  jockeyOne: 'Jockey One',
  leagueGothic: 'League Gothic',
};

export const fontWeight = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
};

export const fontSize = {
  xs: '0.75rem', // 12px
  sm: '0.875rem', // 14px
  base: '1rem', // 16px
  lg: '1.125rem', // 18px
  xl: '1.25rem', // 20px
  '2xl': '1.5rem', // 24px
  '3xl': '1.875rem', // 30px
  '4xl': '2.25rem', // 36px
  '5xl': '3rem', // 48px
  '6xl': '3.75rem', // 60px
  '7xl': '4.5rem', // 72px
  '8xl': '6rem', // 96px
  '9xl': '8rem', // 128px
};

export const lineHeight = {
  none: 1,
  tight: 1.25,
  snug: 1.375,
  normal: 1.5,
  relaxed: 1.625,
  loose: 2,
};

// Function to generate @font-face CSS
export const generateFontFaces = () => `
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterThin}') format('truetype');
    font-weight: ${fontWeight.thin};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterExtraLight}') format('truetype');
    font-weight: ${fontWeight.extraLight};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterLight}') format('truetype');
    font-weight: ${fontWeight.light};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterRegular}') format('truetype');
    font-weight: ${fontWeight.regular};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterMedium}') format('truetype');
    font-weight: ${fontWeight.medium};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterSemiBold}') format('truetype');
    font-weight: ${fontWeight.semiBold};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterBold}') format('truetype');
    font-weight: ${fontWeight.bold};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterExtraBold}') format('truetype');
    font-weight: ${fontWeight.extraBold};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.inter}';
    src: url('${InterBlack}') format('truetype');
    font-weight: ${fontWeight.black};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.jockeyOne}';
    src: url('${JockeyOneRegular}') format('truetype');
    font-weight: ${fontWeight.regular};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.leagueGothic}';
    src: url('${LeagueGothicRegular}') format('truetype');
    font-weight: ${fontWeight.regular};
    font-style: normal;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.leagueGothic}';
    src: url('${LeagueGothicItalic}') format('truetype');
    font-weight: ${fontWeight.regular};
    font-style: italic;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.leagueGothic}';
    src: url('${LeagueGothicCondensed}') format('truetype');
    font-weight: ${fontWeight.regular};
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }
  
  @font-face {
    font-family: '${fontFamily.leagueGothic}';
    src: url('${LeagueGothicCondensedItalic}') format('truetype');
    font-weight: ${fontWeight.regular};
    font-style: italic;
    font-stretch: condensed;
    font-display: swap;
  }
`;

export default {
  fontFamily,
  fontWeight,
  fontSize,
  lineHeight,
  generateFontFaces,
};
